<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			titulo="Validação de Tramitação"
			:max-width="900"
			:is-confirmar-visivel="false"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			@close="fecharModal"
		>
			<template #body>
				<v-row class="mt-1">
					<v-col cols="12" sm="4">
						<label-personalizado
							nome-campo="Documento em"
							obrigatorio-por-padrao
							class="mb-6"
						></label-personalizado>
						<span>{{ textoEntidade }}</span>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado
							nome-campo="Atividade"
							obrigatorio-por-padrao
							apresenta-tooltip
							:mensagem-padrao-tooltip="mensagemTooltipAtividade"
						></label-personalizado>
						<v-autocomplete
							v-model="atividade"
							:items="atividadesDatasource"
							:rules="regrasAtividade"
							placeholder="Selecione"
							item-text="nomeAtividade"
							item-value="idAtividade"
							return-object
							clearable
						></v-autocomplete>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado
							nome-campo="Validar documento"
							obrigatorio-por-padrao
						></label-personalizado>
						<v-autocomplete
							v-model="situacaoDocumento"
							:items="opcoesSituacaoDocumento"
							:rules="regrasSituacaoDocumento"
							placeholder="Selecione"
							item-text="text"
							item-value="value"
							clearable
						></v-autocomplete>
					</v-col>
				</v-row>
				<v-row justify="end" class="mt-0">
					<v-col cols="auto" class="d-flex align-center">
						<botao-cancelar
							v-if="isModoEdicao"
							label="Cancelar"
							class="mr-2"
							@cancelar="cancelarEdicao"
						></botao-cancelar>
						<botao-adicionar
							:label="rotuloBotaoSalvar"
							:desabilitar="!formIsValid"
							@adicionar="adicionarOuSalvar"
						></botao-adicionar>
					</v-col>
				</v-row>
				<v-divider class="my-3"></v-divider>
				<listagem-itens
					:itens="validacoesTramitacao"
					:colunas="colunas"
					:total-itens="totalItens"
					:total-paginas="0"
					:custom-columns="colunasPersonalizadas"
					:tamanho-maximo-colunas="tamanhoMaximoColunas"
					:show-actions="true"
					:show-paginacao="false"
					:textos-do-template-da-listagem-vazia="textosListagemVazia"
				>
					<template #entidade="{ item }">
						<span>{{ filtrarEntidade(item.entidade) }}</span>
					</template>
					<template #situacaoDocumento="{ item }">
						<span>{{ filtrarSituacaoDocumento(item.situacaoDocumento) }}</span>
					</template>
					<template #actions="{ item }">
						<botao-tooltip
							icone="mdi-pencil"
							cor="grey"
							texto="Editar"
							:disabled="isLinhaEmEdicao(item)"
							@click="editarLinha(item)"
							v-az-auth="permissoes.tipoDocumentoValidacaoTramitacaoEditar"
						></botao-tooltip>
						<botao-tooltip
							icone="mdi-delete"
							cor="grey"
							texto="Excluir"
							@click="abrirModalConfirmacaoExclusao(item)"
							v-az-auth="permissoes.tipoDocumentoValidacaoTramitacaoExcluir"
						></botao-tooltip>
					</template>
				</listagem-itens>
			</template>
		</modal>

		<modal-confirmacao
			id="excluirValidacaoTramitacao"
			:exibir="exibirModalConfirmacaoExclusao"
			mensagem="Deseja realmente confirmar esta ação?"
			subtitulo-modal="Após a confirmação ele será removido!"
			titulo-modal="Atenção! Você está prestes a remover uma Validação de Tramitação!"
			@fechar-modal="fecharModalConfirmacaoExclusao"
			@confirmar="confirmarExclusao"
		></modal-confirmacao>
	</v-form>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import BotaoAdicionar from '@/views/components/botoes/adicionar/BotaoAdicionar.vue'
import ListagemItens from '@/views/components/ListagemItens.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import situacaoFilter from '@/views/filters/situacao-filter'
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, entidadeValidacaoTramitacao, situacaoDocumentoValidacaoTramitacao } from '@/core/constants'

export default {
	name: 'modal-validacao-tramitacao',
	components: {
		ModalConfirmacao,
		ListagemItens,
		BotaoAdicionar,
		BotaoCancelar,
		BotaoTooltip,
		LabelPersonalizado,
		Modal,
	},
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		idTipoDocumento: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			formIsValid: false,
			entidade: entidadeValidacaoTramitacao.PEDIDO_UTILIZACAO.value,
			atividade: null,
			situacaoDocumento: null,
			atividadesDatasource: [],
			validacoesTramitacao: [],
			validacaoTramitacaoEmEdicao: null,
			regrasAtividade: [(value) => this.regraObrigatoriedade(value, 'Campo obrigatório!')],
			regrasSituacaoDocumento: [(value) => this.regraObrigatoriedade(value, 'Campo obrigatório!')],
			colunasPersonalizadas: ['entidade', 'situacaoDocumento'],
			tamanhoMaximoColunas: { nomeAtividade: 40 },
			textosListagemVazia: {
				titulo: 'Nenhuma validação de tramitação configurada',
			},
			exibirModalConfirmacaoExclusao: false,
			validacaoTramitacaoParaExcluir: null,
		}
	},
	computed: {
		isModoEdicao() {
			return !!this.validacaoTramitacaoEmEdicao
		},
		rotuloBotaoSalvar() {
			return this.isModoEdicao ? 'Salvar' : 'Adicionar'
		},
		textoEntidade() {
			return this.filtrarEntidade(this.entidade)
		},
		opcoesSituacaoDocumento() {
			return [situacaoDocumentoValidacaoTramitacao.CRIADO, situacaoDocumentoValidacaoTramitacao.JUNTADO]
		},
		colunas() {
			return [
				new TabelaColunaUtils('Documento em', 'entidade'),
				new TabelaColunaUtils('Atividade', 'nomeAtividade'),
				new TabelaColunaUtils('Validar documento', 'situacaoDocumento'),
				new TabelaColunaUtils('Ações', 'actions'),
			]
		},
		totalItens() {
			return this.validacoesTramitacao.length
		},
		mensagemTooltipAtividade() {
			return (
				'Para que a configuração seja validada em Fluxo, é necessário que o Delegate' +
				' validarExistenciaTiposDocumentoPedidoUtilizacaoDelegate seja aplicado em conjunto na atividade selecionada'
			)
		},
	},
	created() {
		this.carregarAtividades()
		this.carregarValidacoesTramitacao()
	},
	methods: {
		...mapActions({
			buscarAtividades: actionTypes.ATA.BUSCAR_ATIVIDADES_FILTRO,
			buscarValidacoesTramitacao: actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_VALIDACOES_TRAMITACAO,
			criarValidacaoTramitacao: actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.CRIAR_VALIDACAO_TRAMITACAO,
			editarValidacaoTramitacao: actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EDITAR_VALIDACAO_TRAMITACAO,
			excluirValidacaoTramitacao: actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EXCLUIR_VALIDACAO_TRAMITACAO,
		}),
		async carregarAtividades() {
			const { itens } = await this.buscarAtividades()
			this.atividadesDatasource = itens[0].atividadesPedido
		},
		async carregarValidacoesTramitacao() {
			const { itens } = await this.buscarValidacoesTramitacao(this.idTipoDocumento)
			this.validacoesTramitacao = itens
		},
		filtrarEntidade(entidade) {
			return situacaoFilter(entidade, entidadeValidacaoTramitacao)
		},
		filtrarSituacaoDocumento(situacaoDocumento) {
			return situacaoFilter(situacaoDocumento, situacaoDocumentoValidacaoTramitacao)
		},
		isLinhaEmEdicao(item) {
			return this.isModoEdicao && this.validacaoTramitacaoEmEdicao.id === item.id
		},
		async adicionarOuSalvar() {
			if (!this.$refs.form.validate()) return

			if (this.isModoEdicao) {
				await this.salvarEdicao()
			} else {
				await this.adicionarLinha()
			}

			this.limparCampos()
		},
		async adicionarLinha() {
			await this.criarValidacaoTramitacao({
				idTipoDocumento: this.idTipoDocumento,
				validacaoTramitacao: this.getPayloadValidacaoTramitacao(),
			})

			await this.carregarValidacoesTramitacao()
			this.mostrarNotificacaoSucesso('Validação de tramitação adicionada com sucesso!')
		},
		async salvarEdicao() {
			await this.editarValidacaoTramitacao({
				idTipoDocumento: this.idTipoDocumento,
				idValidacaoTramitacao: this.validacaoTramitacaoEmEdicao.id,
				validacaoTramitacao: this.getPayloadValidacaoTramitacao(),
			})

			await this.carregarValidacoesTramitacao()
			this.mostrarNotificacaoSucesso('Validação de tramitação alterada com sucesso!')
		},
		getPayloadValidacaoTramitacao() {
			return {
				entidade: this.entidade,
				idAtividade: this.atividade.idAtividade,
				nomeAtividade: this.atividade.nomeAtividade,
				situacaoDocumento: this.situacaoDocumento,
			}
		},
		editarLinha(item) {
			this.validacaoTramitacaoEmEdicao = item
			this.entidade = item.entidade
			this.atividade = this.atividadesDatasource.find((atividade) => atividade.idAtividade === item.idAtividade)
			this.situacaoDocumento = item.situacaoDocumento
		},
		cancelarEdicao() {
			this.limparCampos()
		},
		limparCampos() {
			this.entidade = entidadeValidacaoTramitacao.PEDIDO_UTILIZACAO.value
			this.atividade = null
			this.situacaoDocumento = null
			this.validacaoTramitacaoEmEdicao = null
			this.$refs.form.resetValidation()
		},
		abrirModalConfirmacaoExclusao(item) {
			this.validacaoTramitacaoParaExcluir = item
			this.exibirModalConfirmacaoExclusao = true
		},
		fecharModalConfirmacaoExclusao() {
			this.validacaoTramitacaoParaExcluir = null
			this.exibirModalConfirmacaoExclusao = false
		},
		async confirmarExclusao() {
			const idValidacaoTramitacaoExcluir = this.validacaoTramitacaoParaExcluir.id

			await this.excluirValidacaoTramitacao({
				idTipoDocumento: this.idTipoDocumento,
				idValidacaoTramitacao: idValidacaoTramitacaoExcluir,
			})

			await this.carregarValidacoesTramitacao()

			if (this.isModoEdicao && this.validacaoTramitacaoEmEdicao.id === idValidacaoTramitacaoExcluir) {
				this.limparCampos()
			}

			this.mostrarNotificacaoSucesso('Validação de tramitação excluída com sucesso!')
			this.fecharModalConfirmacaoExclusao()
		},
		fecharModal() {
			this.limparCampos()
			this.$emit('fechar-modal')
		},
	},
}
</script>

<style scoped lang="stylus"></style>
